import { DesignSystemUi } from "@blockdaemon-internal/design-system";
import { Center, Loader } from "@mantine/core";
import type { QueryClient } from "@tanstack/react-query";
import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { Suspense } from "react";

import { AnalyticsProvider } from "../analytics-provider";
import { GlobalErrorBoundary } from "../error-boundary";
import { GlobalErrorListener } from "../global-error-listener";
import { LocaleProvider } from "../i18n/provider";

export type WidgetAppProvidersProps = {
  children: ReactNode;
  queryClient: QueryClient;
  forceColorScheme?: "light" | "dark" | null;
};

export function WidgetAppProviders({
  children,
  queryClient,
  forceColorScheme,
}: WidgetAppProvidersProps) {
  return (
    <DesignSystemUi forceColorScheme={forceColorScheme || undefined}>
      <LocaleProvider>
        <GlobalErrorBoundary>
          <GlobalErrorListener />
          <Suspense
            fallback={
              <Center style={{ height: "100vh" }}>
                <Loader size="lg" />
              </Center>
            }
          >
            <QueryClientProvider client={queryClient}>
              <AnalyticsProvider>{children}</AnalyticsProvider>
            </QueryClientProvider>
          </Suspense>
        </GlobalErrorBoundary>
      </LocaleProvider>
    </DesignSystemUi>
  );
}
